import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

export default function HeatMap(props: any) {
  if (!props.categories) {
    return <></>;
  }
  const options: ApexOptions = {
    chart: {
      type: 'bar',
      toolbar: { show: false },
    },

    plotOptions: {
      bar: {
        columnWidth: '98%',
      },
    },
    colors: ['#8B8296'],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      width: 1,
    },
    tooltip: {
      enabled: false,
    },
    xaxis: {
      categories: props.categories,
      // categories: [
      //   ['5-10', 'KM/H'],
      //   ['11-15', 'KM/H'],
      //   ['16-20', 'KM/H'],
      //   ['21-25', 'KM/H'],
      //   ['26-30', 'KM/H'],
      //   ['31-35', 'KM/H'],
      //   ['36-40', 'KM/H'],
      //   ['41-45', 'KM/H'],
      //   ['46-50', 'KM/H'],
      // ],
      labels: {
        rotate: 0,
        style: {
          fontSize: '11px',
          fontWeight: '18px',
          fontFamily: 'neue-haas-unica',
          cssClass: 'xaxis-columnchart',
          colors: '#8B8296',
        },
      },
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
      padding: {
        top: 20,
      },
    },
  };

  const series: any = [
    {
      name: 'Servings',
      data: props.values,
    },
  ];

  return (
    <div id="chart" className="windspeed">
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={600}
      />
    </div>
  );
}
